import React, { useState, useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { StyledTooltip } from "./Tooltip.js";
import { isStringNullOrEmpty } from "../../utils/string.js";
import "moment-timezone";
import "react-intl";
import { dashCharacter } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import { useClasses } from "./AutoAdjustedWidthTooltip.styles.js";
const AutoAdjustedWidthTooltip = ({ value, showEmptyCharacter = true }) => {
  const { classes } = useClasses();
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef(null);
  useEffect(() => {
    if (textElementRef && textElementRef.current) {
      setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }
  }, [value]);
  function isValueNotEmpty() {
    return value !== null && value !== void 0 && !(typeof value === "string" && isStringNullOrEmpty(value));
  }
  return isValueNotEmpty() ? /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement("div", { ref: textElementRef, className: classes.autoAdjustedWidthTooltipLabel }, value),
      title: /* @__PURE__ */ React.createElement(Box, { className: classes.autoAdjustedWidthTooltip }, value),
      hideTooltip: !isOverflowed
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, showEmptyCharacter ? dashCharacter : null);
};
export {
  AutoAdjustedWidthTooltip
};
//# sourceMappingURL=AutoAdjustedWidthTooltip.js.map
